/**
* 首次登录完善信息 | 弱口令重置
*/
<template>
  <div class="firstLogin">
    <el-dialog :title="title"
               :visible.sync="firstLoginVisible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :destroy-on-close="true"
               width="50%"
               center>
      <el-alert v-if="status === 'weakPwd'"
                :title="`检测到您的密码弱口令，请进行修改：密码长度${pwd_min}-${pwd_max}字符，需要包含大小写字母、数字和特殊字符`"
                :closable="false"
                type="warning"/>
      <div class="body">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step v-for="step in stepList" :title="step.title" :key="step.index"/>
        </el-steps>
        <el-form ref="firstLoginInfo"
                 :model="firstLoginInfo"
                 label-position="top"
                 size="medium"
                 label-width="100px">
          <template v-if="active === 0">
            <el-form-item label="登录账号">
              <el-input v-model="firstLoginInfo.username" disabled/>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="firstLoginInfo.nickname" disabled/>
            </el-form-item>
          </template>
          <template v-if="active === 1">
            <el-form-item label="密码"
                          prop="password"
                          key="password"
                          :rules="[
                          { required: true, message: '请填写新密码', trigger: ['blur', 'change'] },
                          { min: pwd_min, max: pwd_max, message: `长度在 ${pwd_min} 到 ${pwd_max} 个字符`, trigger: 'blur' },
                          { validator: validateStrongPwd, trigger: 'blur' },
                        ]">
              <el-input type="password" v-model="firstLoginInfo.password" show-password autocomplete="off"/>
            </el-form-item>
            <el-form-item label="再次确认密码"
                          prop="passwordAgain"
                          key="passwordAgain"
                          :rules="[
                          { required: true, message: '请再次输入确认密码', trigger: ['blur', 'change'] },
                          { validator: checkEquality, trigger: 'blur' },
                          { min: pwd_min, max: pwd_max, message: `长度在 ${pwd_min} 到 ${pwd_max} 个字符`, trigger: 'blur' },
                          { validator: validateStrongPwd, trigger: 'blur' },
                        ]">
              <el-input type="password" v-model="firstLoginInfo.passwordAgain" show-password autocomplete="off"/>
            </el-form-item>
          </template>
          <template v-if="status === 'firstLogin' && active === 2">
            <el-form-item label="手机号"
                          prop="phone"
                          key="phone"
                          :rules="[
                          { required: true, message: '请填写手机号', trigger: ['blur', 'change'] },
                          { required: true, pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/, message: '请填写正确的手机号格式', trigger: 'blur' }
                        ]">
              <el-input v-model.number="firstLoginInfo.phone" clearable/>
            </el-form-item>
            <el-form-item label="邮箱"
                          prop="email"
                          key="email"
                          :rules="[
                          { required: false, message: '请填写邮箱地址', trigger: ['blur', 'change'] },
                          { type: 'email', message: '请填写正确的邮箱格式', trigger: ['blur'] }
                        ]">
              <el-input v-model="firstLoginInfo.email" clearable/>
            </el-form-item>
          </template>
          <template v-if="status === 'firstLogin' && accountType && active === 3">
            <el-form-item label="纳税人识别号"
                          prop="taxId"
                          key="taxId"
                          :rules="[
                          { required: this.accountType, message: '单位账号，请填写纳税人识别号', trigger: ['blur', 'change'] }
                        ]">
              <el-input v-model="firstLoginInfo.taxId" clearable/>
            </el-form-item>
            <el-form-item label="地址"
                          prop="address"
                          key="address"
                          :rules="[
                          { required: this.accountType, message: '单位账号，请填写地址', trigger: ['blur', 'change'] }
                        ]">
              <el-input v-model="firstLoginInfo.address" clearable/>
            </el-form-item>
            <el-form-item label="开户行"
                          prop="bank"
                          key="bank"
                          :rules="[
                          { required: this.accountType, message: '单位账号，请填写开户行', trigger: ['blur', 'change'] }
                        ]">
              <el-input v-model="firstLoginInfo.bank" clearable/>
            </el-form-item>
            <el-form-item label="银行账号"
                          prop="bankAccount"
                          key="bankAccount"
                          :rules="[
                          { required: this.accountType, message: '单位账号，请填写银行账号', trigger: ['blur', 'change'] }
                        ]">
              <el-input v-model="firstLoginInfo.bankAccount" clearable/>
            </el-form-item>
          </template>
          <template v-if="(status === 'firstLogin' && ((accountType && active === 4) || (!accountType && active === 3)))
                          || (status === 'weakPwd' && active === 2)">
            <el-form-item>
              <p class="flex">
                <span class="prefix">用户名：</span>
                <span class="content">{{ firstLoginInfo.username }}</span>
              </p>
              <p class="flex">
                <span class="prefix">联系人姓名：</span>
                <span class="content">{{ firstLoginInfo.nickname }}</span>
              </p>
              <p class="flex">
                <span class="prefix">新密码：</span>
                <span class="content">{{ firstLoginInfo.password }}</span>
              </p>
              <p class="flex">
                <span class="prefix">手机号：</span>
                <span class="content">{{ firstLoginInfo.phone }}</span>
              </p>
              <p class="flex" v-if="firstLoginInfo.email">
                <span class="prefix">邮箱：</span>
                <span class="content">{{ firstLoginInfo.email }}</span>
              </p>
              <p class="flex" v-if="firstLoginInfo.taxId">
                <span class="prefix">纳税人识别号：</span>
                <span class="content">{{ firstLoginInfo.taxId }}</span>
              </p>
              <p class="flex" v-if="firstLoginInfo.address">
                <span class="prefix">地址：</span>
                <span class="content">{{ firstLoginInfo.address }}</span>
              </p>
              <p class="flex" v-if="firstLoginInfo.bank">
                <span class="prefix">开户行：</span>
                <span class="content">{{ firstLoginInfo.bank }}</span>
              </p>
              <p class="flex" v-if="firstLoginInfo.bankAccount">
                <span class="prefix">银行：</span>
                <span class="content">{{ firstLoginInfo.bankAccount }}</span>
              </p>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="previousStep" v-if="active > 0">上一步</el-button>
        <el-button type="primary" @click="nextStep('firstLoginInfo')" v-if="active !== stepList.length - 1">下一步</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="active === stepList.length - 1">完成</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // api
  import { completeInfo } from '@/api/login.js'
  import { mapGetters, mapMutations } from "vuex";
  // config
  import { validateStrongPwd, PWD } from '@/config/bkjcStroeConfig.js'
  export default {
    name: "firstLogin",
    data() {
      return {
        active: 0,  // 当前所处步骤
        validateStrongPwd: validateStrongPwd,
        pwd_min: PWD.min,
        pwd_max: PWD.max
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',  // 获取accountType
        'firstLoginVisible', // 首次登录弹窗开关
        'firstLoginInfo'  // 首次登录填写信息
      ]),
      // Dialog使用状态：首次登录 or 弱口令重置
      status() {
        if(this.firstLoginInfo.completeInfo && !this.firstLoginInfo.isStrongPwd) {
          // 弱口令重置：completeInfo是true的情况下isStrongPwd是false
          return 'weakPwd';
        } else {
          // 首次登录：只要completeInfo是false，则为首次登陆
          return 'firstLogin';
        }
      },
      title() {
        if(this.status === 'firstLogin') return '首次登录完善信息';
        else if(this.status === 'weakPwd') return '修改密码';
        else return '';
      },
      accountType() {
        // 账号类型
        // 0: 个人账号->false 1: 单位账号->true
        if (this.userInfo && this.userInfo.additional && this.userInfo.additional.accountType !== undefined) {
          return !!Number(this.userInfo.additional.accountType);
        } else {
          return false;
        }
      },
      // 步骤配置
      stepList() {
        if(this.status === 'firstLogin') {
          if(this.accountType) {  // 单位账号
            return [
              { index: 0, title: '确认账号信息' },
              { index: 1, title: '修改密码' },
              { index: 2, title: '填写联系方式' },
              { index: 3, title: '填写开票信息' },
              { index: 4, title: '完成'}
            ];
          } else {  // 个人账号
            return [
              { index: 0, title: '确认账号信息' },
              { index: 1, title: '修改密码' },
              { index: 2, title: '填写联系方式' },
              { index: 3, title: '完成'}
            ];
          }
        } else if(this.status === 'weakPwd') {
          return [
            { index: 0, title: '确认账号信息' },
            { index: 1, title: '修改密码' },
            { index: 2, title: '完成'}
          ];
        }
      }
    },
    watch: {
      'firstLoginInfo.nickname': {
        immediate: true,
        handler() {
          // 重置步骤
          this.active = 0;
        }
      }
    },
    created() {},
    mounted() {},
    updated() {},
    methods: {
      ...mapMutations({
        setFirstLoginInfo: 'SET_FIRSTLOGININFO', // 记录首次登录填写信息
      }),
      // 校验两次密码是否相等
      checkEquality(rule, value, callback) {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.firstLoginInfo.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
      // 上一步
      previousStep() {
        this.active -= 1;
      },
      // 下一步，本步骤表单验证
      nextStep(name) {
        this.$refs[name].validate((valid) => {
          if(valid) {
            // 通过验证，下一步
            this.active += 1;
          }
        });
      },
      // 提交
      handleSubmit() {
        completeInfo(this.firstLoginInfo).then(res => {
          if(res.status === 200){
            if(this.status === 'firstLogin') {
              this.$message.success('成功修改用户信息，可先添加联系人信息');
              this.firstLoginClose();
            } else if(this.status === 'weakPwd') {
              this.$message.success('成功修改密码');
              this.dialogClose();
            }
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      // 关闭对话框
      dialogClose() {
        this.$store.commit('setFirstLoginVisible', false);
        this.setFirstLoginInfo({});
        localStorage.setItem('isStrongPwd', 'true');
      },
      // 关闭首次登录对话框
      firstLoginClose() {
        // 关闭对话框
        this.dialogClose();
        // 页面跳转
        let query = {
          realName: this.firstLoginInfo.nickname,
          phone: this.firstLoginInfo.phone,
          email: this.firstLoginInfo.email
        };
        // 首次信息完善后自动跳转至添加联系人页面
        this.toPageId('/contacts', query);
      },
      // 页面跳转 传递查询参数
      toPageId (path, query) {
        this.$router.push({
          'path': `${path}`,
          query
        });
      },
    }
  }
</script>

<style scoped lang="scss">
  >>>.el-dialog{
    .el-dialog__header{
      padding: 60px 20px 10px;
      .el-dialog__title{
        font-size: 30px;
      }
    }
    .el-dialog__body{
      padding: 0 15% 10px;
    }
    .body{
      margin-top: 30px;
      .el-form{
        padding-top: 10px;
        .prefix{
          flex: 1;
          text-align: end;
        }
        .content{
          flex: 2;
        }
        input{
          border: 1px solid #aaaaaa;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/firstLogin/index.vue